import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../style/theme';
import { colors } from '../../../style/colors';

interface StyleProps {
  withUnlimitedCredits?: boolean;
}

export const useStyles = makeStyles<ITheme, StyleProps>((theme) => ({
  contentContainer: {
    padding: '0 24px',
  },
  contentTopDescription: {
    padding: '16px 0 24px 0',
    maxWidth: '725px',
  },
  indicator: {
    color: 'red',
  },
  tabLabel: {
    fontSize: '16px',
    lineHeight: '21px',
    fontWeight: 'bold',
    color: colors.darkestBlue,
  },
}));
